import React, { useState, useEffect } from 'react';

const TimeSelector = ({ value, onChange }) => {  
    
    const roundToNearestInterval = (minutes) => {
    const intervals = [0, 15, 30, 45];
    return intervals.reduce((prev, curr) => {
      return Math.abs(curr - minutes) < Math.abs(prev - minutes) ? curr : prev;
    });
  };

  const [hours, setHours] = useState(value ? parseInt(value.split(':')[0]) : 0);
  const [minutes, setMinutes] = useState(value ? roundToNearestInterval(parseInt(value.split(':')[1])) : 0);

useEffect(() => {
  if (value) {
    const [h, m] = value.split(':');
    const parsedH = parseInt(h);
    const parsedM = parseInt(m);
    if (parsedH !== hours || parsedM !== minutes) {
      setHours(parsedH);
      setMinutes(roundToNearestInterval(parsedM));
    }
  }
}, [value]);

//   const getNextMinuteInterval = (currentMinutes, increment) => {
//     const intervals = [0, 15, 30, 45];
//     const currentIndex = intervals.indexOf(currentMinutes);
//     if (increment) {
//       return intervals[(currentIndex + 1) % intervals.length];
//     } else {
//       return intervals[(currentIndex - 1 + intervals.length) % intervals.length];
//     }
//   };

  const handleIncrement = (field) => {

  if (field === 'hours') {

    const newHours = (hours + 1) % 24;   
    setHours(newHours);
    emitChange(newHours, minutes);
  } else {
    const intervals = [0, 15, 30, 45];
    const currentIndex = intervals.indexOf(minutes);
    const isLastInterval = currentIndex === intervals.length - 1;
    
    let newMinutes, newHours = hours;

    if (isLastInterval) {
      newMinutes = intervals[0]; 
      newHours = (hours + 1) % 24;
    } else {
      newMinutes = intervals[currentIndex + 1];
    }

    setMinutes(newMinutes);
    setHours(newHours);
    emitChange(newHours, newMinutes);
  }
};

const handleDecrement = (field) => {

  if (field === 'hours') {   
    const newHours = (hours - 1 + 24) % 24;
    setHours(newHours);
    emitChange(newHours, minutes);
  } else {
    const intervals = [0, 15, 30, 45];
    const currentIndex = intervals.indexOf(minutes);
    const isFirstInterval = currentIndex === 0;

    let newMinutes, newHours = hours;

    if (isFirstInterval) {
      newMinutes = intervals[intervals.length - 1]; // roll to 45
      newHours = (hours - 1 + 24) % 24; // decrement hour
    } else {
      newMinutes = intervals[currentIndex - 1];
    }

    setMinutes(newMinutes);
    setHours(newHours);
    emitChange(newHours, newMinutes);
  }
};


  const emitChange = (h, m) => {
    const formattedHours = h.toString().padStart(2, '0');
    const formattedMinutes = m.toString().padStart(2, '0');
    onChange && onChange({
      target: { value: `${formattedHours}:${formattedMinutes}` }
    });
  };

  return (
    <div className="time-selector">
      <div className="time-field">
        <button type="button" onClick={() => handleIncrement('hours')} className="spinner-button up"></button>
        <span>{hours.toString().padStart(2, '0')}</span>
        <button type="button" onClick={() => handleDecrement('hours')} className="spinner-button down"></button>
      </div>
      <span className="time-separator">:</span>
      <div className="time-field">
        <button type="button" onClick={() => handleIncrement('minutes')} className="spinner-button up"></button>
        <span>{minutes.toString().padStart(2, '0')}</span>
        <button type="button" onClick={() => handleDecrement('minutes')} className="spinner-button down"></button>
      </div>
    </div>
  );
}
export default TimeSelector;
